import { navigation } from '@/navigation';
import { findSettingsSectionByLegacyTab, settingsSectionHref } from './settings-sections';

/** Old tab that left System settings for a page of its own. */
const INTEGRATIONS_TAB = 'integrations';

/**
 * Where an old `/system-settings?tab=…` link leads now: the section holding that tab, with its
 * `step`; integrations to their own page; anything else to the overview.
 */
export function legacySettingsTarget(search: string): string {
  const params = new URLSearchParams(search);
  const tab = params.get('tab');
  if (tab === INTEGRATIONS_TAB) return navigation.integrations();

  const section = findSettingsSectionByLegacyTab(tab);
  if (!section) return navigation.settings();

  const step = params.get('step');
  const query = step ? `?${new URLSearchParams({ step }).toString()}` : '';
  return `${settingsSectionHref(section)}${query}`;
}
